module.exports = __webpack_public_path__ + "img/banner4 中文 手机.23eb63b0.png";